export default {
    FILTER_TEXT: "text",
    FILTER_RANGE: "range",
    FILTER_CATEGORIES: "categories",
    FILTER_TYPES: "types",
}
